export const GC_USER_ID = 'user-id'
export const GC_AUTH_TOKEN = 'auth-token'
export const GC_REFRESH_TOKEN = 'refresh-token'
export const GC_REFRESH_TOKEN_EXPIRES = 'refresh-token-expires'
